import React, { Component } from "react";
import { number, string } from "prop-types";
import cn from "classnames";

class Badge extends Component {
    static propTypes = {
        count: number,
        className: string,
    };

    static defaultProps = {
        className: undefined,
        count: null,
    };

    render() {
        const { count, className } = this.props;

        if (count === 0) {
            return null;
        }
        const componentClassName = cn({ badge: !className }, className);
        return (
            <div className={componentClassName}>
                <span>{count > 99 ? "+99" : count}</span>
            </div>
        );
    }
}

export default Badge;
